export const getTimeStamp = () => {
  const offset = new Date().getTimezoneOffset()
  const oldDateObj = new Date()
  const newDateObj = new Date()
  newDateObj.setTime(oldDateObj.getTime() + offset)

  return newDateObj.toISOString()
}
